import React, { useState } from 'react';
import CardComponent       from '../CardComponent';
import "../CardComponent.scss";

const ContainerCard = ({ cardType, data, getProperties }) => {
  const [state, setState] = useState({
    data: data
  })
  const setSavePropertyInDate = (property) => {
    setState(prevState => ({
      ...prevState,
      data: prevState.data.map(item =>
        item.id === property.propertyId
          ? { ...item, favourite: property }
          : item
      )
    }));
    !!getProperties && getProperties()
  };

  const removeSavePropertyInDate = (property) => {
    setState(prevState => ({
      ...prevState,
      data: prevState.data.map(item =>
        item.id === property.propertyId
          ? { ...item, favourite: null }
          : item
      )
    }));
    !!getProperties && getProperties()
  };

  return <div>
    <div className={ "cards-container" }>
      {
        state.data?.length > 0 && state.data.map(item => <CardComponent setSavePropertyInDate={ setSavePropertyInDate }
                                                                        removeSavePropertyInDate={removeSavePropertyInDate}
                                                            cardType={ cardType } data={ cardType === "recentViewed" ? item?.property : item }/>
        )
      }
    </div>
  </div>
}

export default ContainerCard